import * as go from "gojs";
// import { ReactDiagram, ReactOverview } from "gojs-react";
// import React, { useRef, useState, useEffect } from "react";
import { ReactDiagram } from "gojs-react";
import "./styles.css";

// function mayWorkFor(node1, node2) {
//   if (!(node1 instanceof go.Node)) return false; // must be a Node
//   if (node1 === node2) return false; // cannot work for yourself
//   if (node2.isInTreeOf(node1)) return false; // cannot work for someone who works for you
//   return true;
// }

const GoTree = ({ data, vertical = false }) => {
  // const [observed, setObserved] = useState(null);
  // const diagramRef = useRef();

  // useEffect(() => {
  //   if (!diagramRef.current) return;
  //   const diagram = diagramRef.current.getDiagram(); // refs are up-to-date
  //   if (diagram instanceof go.Diagram) {
  //     setObserved(diagram);
  //     // diagram.addDiagramListener("ChangedSelection", props.onDiagramChange);
  //     // diagram.addDiagramListener(
  //     //   "ExternalObjectsDropped",
  //     //   props.onDiagramChange
  //     // );
  //   }

  //   return () => {
  //     if (diagramRef.current) return;
  //     const currentDiagram = diagramRef.current.getDiagram();
  //     if (currentDiagram instanceof go.Diagram) {
  //       setObserved(null);
  //       // currentDiagram.removeDiagramListener(
  //       //   "ChangedSelection",
  //       //   props.onDiagramChange
  //       // );
  //       // currentDiagram.removeDiagramListener(
  //       //   "ExternalObjectsDropped",
  //       //   props.onDiagramChange
  //       // );
  //     }
  //   };
  // }, [diagramRef]);

  const initDiagram = () => {
    const $ = go.GraphObject.make;

    // set your license key here before creating the diagram: go.Diagram.licenseKey = "...";

    const diagram = $(go.Diagram, {
      initialDocumentSpot: go.Spot.Center,
      initialViewportSpot: go.Spot.Center,
      initialScale: 0.8,
      "undoManager.isEnabled": true, // включен менеджер отмены (undoManager), который позволяет отслеживать изменения модели и отменять их при необходимости
      // 'undoManager.maxHistoryLength': 0,  // uncomment disable undo/redo functionality
      // "clickCreatingTool.archetypeNodeData": {
      //   name: "new node",
      // },

      "toolManager.mouseWheelBehavior": go.WheelMode.Zoom,

      model: $(go.TreeModel),
      layout: $(go.TreeLayout, {
        treeStyle: go.TreeStyle.Layered,
        arrangement: go.TreeArrangement.Horizontal,
        // properties for most of the tree:
        angle: vertical ? 0 : 90,
        layerSpacing: 50,
        sorting: go.TreeSorting.Ascending,
        comparer: (a, b) => {
          const av = a.node.data.name;
          const bv = b.node.data.name;
          if (av < bv) return -1;
          if (av > bv) return 1;
          return 0;
        },
      }),
    });

    diagram.nodeTemplate = $(
      go.Node,
      go.Panel.Spot,
      {
        // isShadowed: true,
        shadowOffset: new go.Point(0, 2),
        selectionObjectName: "BODY",

        // mouseDragEnter: (e, node, prev) => {
        //   const diagram = node.diagram;
        //   const selnode = diagram.selection.first();
        //   if (!mayWorkFor(selnode, node)) return;
        //   const shape = node.findObject("SHAPE");
        //   if (shape) {
        //     shape._prevFill = shape.fill;
        //     shape.fill = "#f0f9ff";
        //   }
        // },
        // mouseDragLeave: (e, node, next) => {
        //   const shape = node.findObject("SHAPE");
        //   if (shape && shape._prevFill) {
        //     shape.fill = shape._prevFill;
        //   }
        // },
        // mouseDrop: (e, node) => {
        //   const diagram = node.diagram;
        //   const selnode = diagram.selection.first();
        //   if (mayWorkFor(selnode, node)) {
        //     const link = selnode.findTreeParentLink();
        //     if (link !== null) {
        //       link.fromNode = node;
        //     } else {
        //       diagram.toolManager.linkingTool.insertLink(
        //         node,
        //         node.port,
        //         selnode,
        //         selnode.port
        //       );
        //     }
        //   }
        // },
      },
      $(
        go.Panel,
        go.Panel.Auto,
        { name: "BODY" },
        $(go.Shape, "Rectangle", {
          name: "SHAPE",
          strokeWidth: 2,
          stroke: "#f08400",
          portId: "",
          spot1: go.Spot.TopLeft,
          spot2: go.Spot.BottomRight,
          fill: "#fff7ee",
        }),
        $(
          go.Panel,
          "Table",
          {
            minSize: new go.Size(130, NaN),
            margin: new go.Margin(10, 15, 10, 15),
            defaultAlignment: go.Spot.Left,
          },
          $(
            go.TextBlock, // the name
            {
              row: 0,
              column: 0,
              font: "bold 12pt Segoe UI,sans-serif",
              isMultiline: false,
              minSize: new go.Size(10, 16),
              margin: new go.Margin(0, 0, 10, 0),
            },
            new go.Binding("text", "name").makeTwoWay()
          ),
          $(
            go.Panel,
            "Horizontal",
            {
              row: 1,
              column: 0,
            },
            $(
              go.Panel,
              go.Panel.Spot,
              new go.Binding("isClipping", "manager_avatar", function (avatar) {
                return !!avatar; // Включаем isClipping только если есть аватар
              }),
              { alignment: go.Spot.Center },
              $(go.Shape, "Circle", {
                desiredSize: new go.Size(30, 30),
                fill: "#fff", // Цвет фона круга
                strokeWidth: 0, // Толщина обводки
              }),
              $(
                go.Picture,
                {
                  width: 30,
                  height: 30,
                  desiredSize: new go.Size(30, 30),
                  visible: false, // Скрываем картинку по умолчанию
                },
                new go.Binding("source", "manager_avatar", function (avatar) {
                  return avatar || null; // Если avatar отсутствует, возвращаем null
                }),
                new go.Binding("visible", "manager_avatar", function (avatar) {
                  return !!avatar; // Показываем картинку только если avatar существует
                })
              ),
              $(
                go.TextBlock,
                {
                  font: "bold 12pt Segoe UI, sans-serif",
                  stroke: "#f08400",
                  textAlign: "center",
                  verticalAlignment: go.Spot.Center,
                },
                new go.Binding("text", "", function (data) {
                  if (!data.manager_avatar && data.manager_fullname) {
                    const names = data.manager_fullname.split(" ");
                    const initials =
                      (names[0]?.[0] || "") + (names[1]?.[0] || "");
                    return initials.toUpperCase();
                  }
                  return ""; // Если есть avatar, текст не отображается
                })
              )
            ),

            $(
              go.TextBlock,
              {
                font: "10pt Segoe UI,sans-serif",
                isMultiline: false,
                minSize: new go.Size(10, 16),
                margin: new go.Margin(0, 0, 0, 10),
              },
              new go.Binding("text", "manager_fullname", function (val) {
                return val || "Руководитель отсутствует";
              }).makeTwoWay()
            )
          )
        )
      )
    );

    diagram.linkTemplate = new go.Link(
      //  go.Routing.AvoidsNodes - каждый сегмент маршрута будет либо горизонтальным, либо вертикальным, но при этом маршрут будет стараться избегать пересечения с узлами
      { routing: go.Routing.AvoidsNodes, corner: 2 }
    ).add(
      // the link path, a Shape
      new go.Shape({ strokeWidth: 1.5, stroke: "#f08400" })
      // // if we wanted an arrowhead we would also add another Shape with toArrow defined:
      // new go.Shape({ toArrow: "Standard", stroke: null })
    );

    // the context menu allows users to make a position vacant,
    // remove a role and reassign the subtree, or remove an office
    // diagram.nodeTemplate.contextMenu = $(
    //   "ContextMenu",
    //   $("ContextMenuButton", $(go.TextBlock, "test"), {
    //     click: function (e, obj) {
    //       var node = obj.part.adornedPart;
    //       if (node !== null) {
    //         var thisoffice = node.data;
    //         console.log(thisoffice);
    //       }
    //     },
    //   })
    // );

    return diagram;
  };

  // const initOverview = () => {
  //   const $ = go.GraphObject.make;
  //   const observed = new go.Set();
  //   const overview = $(go.Overview, {
  //     observed: observed,
  //   });
  //   return overview;
  // };

  const handleModelChange = (changes) => {
    // console.log("changes", changes);
  };

  return (
    data && (
      <div className="diagram-container">
        <div className="diagram-block"></div>
        <ReactDiagram
          skipsDiagramUpdate={false}
          initDiagram={initDiagram}
          divClassName="diagram-component"
          nodeKeyProperty="uuid"
          nodeDataArray={data}
          onModelChange={handleModelChange}
        />
        {/* <ReactOverview
            initOverview={initOverview}
            divClassName="overview-component"
            style={{ backgroundColor: "#eee" }}
            observedDiagram={observed}
          /> */}
      </div>
    )
  );
};

export default GoTree;
